import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { hideCreateSkillModal, showCreateSkillGroupModal } from "../../actions";
import _ from "lodash";

import { CreateSkillModal } from "./CreateSkillModal";
import {
  updateCreateSkillFormValues,
  clearCreateSkillModalValues,
  createSkill,
} from "../../actions/createSkill";
import { getAllSkillGroups } from "../../actions/skills";

class CreateSkillModalController extends Component {
  constructor(props) {
    super(props);

    this.formUpdated = this.formUpdated.bind(this);
    this.formSubmitted = this.formSubmitted.bind(this);
  }

  formSubmitted(event) {
    const { createSkill, data } = this.props;
    event.preventDefault();
    if (!data.isRequesting) {
      createSkill(data);
    }
  }

  formUpdated(event) {
    const { updateCreateSkillFormValues, data } = this.props;
    const { target } = event;

    // Note this assumes that each field in the modal is named the same as the validation boolean
    // in the reducer's data, but in a readable fashion:
    // e.g.: Activity Name => activityName => activityNameValid
    // Where the first name is the name of the field in the modal, the second is the key generated from that name,
    // and the third is the name of validation boolean that we will update.
    const key = _.camelCase(target.name);
    let value = target.value;

    updateCreateSkillFormValues({
      ...data,
      [key]: value,
      [`${key}Valid`]: isValid(key, target.value),
    });
  }

  componentDidMount() {
    const { getAllSkillGroups } = this.props;
    getAllSkillGroups();
  }

  getSkillGroups() {
    this.props.getAllSkillGroups();
  }

  render() {
    const {
      show,
      hideCreateSkillModal,
      data,
      clearCreateSkillModalValues,
      showCreateSkillGroupModal,
    } = this.props;
    var skillGroups = [];
    if (this.props.skillGroups.length > 0) {
      skillGroups = this.props.skillGroups.map((item) => {
        return item.name;
      });
    }
    return (
      <CreateSkillModal
        show={show}
        hide={() => {
          clearCreateSkillModalValues();
          hideCreateSkillModal();
        }}
        data={{
          skillNameValidation: validationState(data.skillNameValid),
          skillGroupValidation: validationState(data.skillGroupValid),
          skillTypeValidation: validationState(data.skillTypeValid),
          formValid: formValid(data),
          isRequesting: data.isRequesting,
          skillGroups: skillGroups,
        }}
        updated={this.formUpdated}
        submitted={this.formSubmitted}
        showCreateSkillGroupModal={showCreateSkillGroupModal}
      />
    );
  }
}

const isValid = (name, value) => {
  switch (name) {
    case "skillName":
      return !!value;
    case "skillGroup":
      return !!value;
    case "skillType":
      return !!value;
    default:
      return false;
  }
};

const validationState = (isValid) => {
  return isValid ? "success" : "error";
};

const formValid = (data) => {
  return data.skillNameValid && data.skillGroupValid && data.skillTypeValid;
};

CreateSkillModalController.propTypes = {
  show: PropTypes.bool.isRequired,
  hideCreateSkillModal: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  updateCreateSkillFormValues: PropTypes.func.isRequired,
  clearCreateSkillModalValues: PropTypes.func.isRequired,
  createSkill: PropTypes.func.isRequired,
  showCreateSkillGroupModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  hideCreateSkillModal,
  clearCreateSkillModalValues,
  updateCreateSkillFormValues,
  createSkill,
  getAllSkillGroups,
  showCreateSkillGroupModal,
};

const mapStateToProps = (state) => ({
  data: state.ui.createSkillData,
  show: state.ui.createSkill.show,
  skillGroups: state.skills.skillGroups,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateSkillModalController);



// WEBPACK FOOTER //
// ./src/components/createSkillModal/CreateSkillModalController.js